import React, { useState } from 'react';
import Modal from 'react-modal';
import cx from '../../../styles';
import { Icon } from '../Icon';
import BlockUnblockUser from '../BlockUnblockUser'

const BlockedPostPopup = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const onActionClick = () => {
        setIsOpen(true);
    }
    const toggleModal = () => {
        setIsOpen(false);
    }
    const onClose = () => {
        window.location = '/feed'
    }
    return (
        <Modal isOpen={props.isOpen}
            onRequestClose={()=>{props.onModalClose();onClose()}}
            overlayClassName="blocked-post-modal">

            <div className="blocked-post-component">
                <span className={cx("close-modal")} onClick={()=>{props.onModalClose();onClose()}}>
                    <Icon name="cross-regular-dark-smd" />
                </span>
                <div className={cx("wrapper")}>
                    <p className={cx('content')}>{props.t('blocked_post')} <span onClick={onActionClick}>{props.t('here')}</span></p>
                </div>
                {
                    props.block_user && 
                    <BlockUnblockUser entityType={'profile'} entityId={props.block_user.blocked_user_id} status={0} userName={'user'} isOpen={isOpen} toggleModal={toggleModal} blockUser={false} resetPage={true}/>
                }
            </div>
        </Modal>
    );
}

export default BlockedPostPopup;
